<template>
  <div class="order-detail">
    <div class="status">
      <div class="back">
        <van-icon @click="$router.goBack(delta)" class="icon-left" name="arrow-left" />
      </div>
      <div class="status-text">
        <img :src="statusIcon[order.status]" alt="">
        <p>{{ statusText }}</p>
      </div>
    </div>
    <scroll ref="scroll" clickable :class="['scroll', currentReturn===2 ? 'send' : '']">
      <div class="logistics">
        <template v-if="order.status < 5">
          <img @click="openExpress" src="./car@2x.png" alt="">
          <p @click="openExpress">{{ order.status === 3 ? '卖家已发货：' + order.express_company + order.express_no : order.status === 4 ? '您的订单已被签收' : '暂无物流信息' }}</p>
          <van-icon @click="openExpress" color="#AEAEAE" class="icon-right" name="arrow" />
        </template>
        <template v-else>
          <p>退款总金额</p>
          <div style="flex: 1;"></div>
          <span>¥{{ order.amount }}</span>
        </template>
      </div>
      <div class="return-address" v-if="currentReturn===2">
        <h4>退货地址</h4>
        <div class="address">
          <img src="./add@2x.png" alt="">
          <div class="info">
            <p>{{ order.receiver_name }} <span>{{ order.receiver_mobile }}</span></p>
            <span>{{ order.receiver_address }}</span>
          </div>
        </div>
      </div>
      <div class="address" v-if="order.status !== 5">
        <img src="./add@2x.png" alt="">
        <div class="info">
          <p>{{ order.receiver_name }} <span>{{ order.receiver_mobile }}</span></p>
          <span>{{ order.receiver_address }}</span>
        </div>
      </div>
      <div class="progress" v-if="order.status === 5 && order.return_status !== 3">
        <div v-for="item in 4" :key="item" class="step">
          <p>{{ refundStatus[item] }}</p>
          <img v-if="item <= currentReturn && item !== 4" src="./1@2x.png" alt="">
          <img v-if="currentReturn === 4 && item === 4" src="./yiwancheng@2x.png" alt="">
          <img v-if="item > currentReturn" src="./wancheng@2x.png" alt="">
          <div class="line" v-if="item < 4"></div>
        </div>
      </div>
      <div class="form" v-if="currentReturn===2">
<!--        <div class="input" @click="showPicker=true">-->
<!--          <label :class="{active: company}">{{ company || '请选择快递公司' }}</label>-->
<!--          <van-icon class="icon-right" name="arrow" />-->
<!--        </div>-->
        <div class="input">
          <input @blur.prevent="inputBlur" v-model="expressNum" type="text" placeholder="请输入物流单号">
          <van-icon class="scan-icon" name="scan" />
        </div>
      </div>
      <div class="order">
        <order-store :store="order.shop"/>
        <div class="goods" v-for="(goods) in goods" :key="goods.id" @click="$router.push('/goods/' + goods.goodsid)">
          <OrderItem :goods="goods" :size-drop="false" price-show/>
          <div class="control">
            <button @click.stop="refunds(goods)" v-if="order.status === 1 || order.status === 3">申请退款</button>
            <button v-if="order.status === 4 && !goods.evaluate_status" @click.stop="evaluation(goods)">评价</button>
          </div>
        </div>
        <div class="control" v-if="order.status === 0">
          <p>交易将在<van-count-down @finish="getDetail" :time="cancelTime" />后关闭</p>
          <button @click="showPay=true">付款</button>
        </div>
      </div>
      <div class="connect" @click="chat">
        <img src="./kefu@2x.png" alt="">
        <span>联系客服</span>
      </div>
      <div class="order-intro">
        <template v-if="order.status !== 5">
          <p v-if="order.remark"><span>订单备注</span>{{ order.remark }}</p>
          <p><span>订单编号</span>{{ order.order_no }}</p>
          <p><span>创建时间</span>{{ order.create_time }}</p>
          <p><span>支付方式</span>{{ !order.pay_time ? '未支付' : order.pay_channel === 1 ? '微信支付' : '支付宝支付' }}</p>
          <p><span>支付时间</span>{{ order.pay_time || '未支付' }}</p>
        </template>
        <template v-else>
          <p><span>退款原因</span>{{ order.reason }}</p>
          <p><span>退款金额</span>¥{{ order.amount }}</p>
          <p><span>申请时间</span>{{ order.create_time }}</p>
          <!--        <p><span>退款编号</span>2566465666454</p>-->
        </template>
      </div>
      <div class="btns" v-if="order.status === 4">
        <button>删除订单</button>
        <button @click="openExpress">查看物流</button>
        <button class="red" @click="buy">再次购买</button>
      </div>
      <div class="btns" v-if="order.status === 0">
        <button @click="cancelOrder">取消订单</button>
        <button class="red" @click="showPay=true">立即付款</button>
      </div>
      <div class="btns" v-if="order.status === 3">
        <button @click="openExpress">查看物流</button>
        <button class="red" @click="confirmDelivery">确认收货</button>
      </div>
    </scroll>
    <div class="bottom-btn" v-if="currentReturn===2" @click="submitExpress">提交物流单号</div>
    <van-dialog @confirm="nativePay" v-model="showPay" show-cancel-button title="请选择支付方式">
      <pay-select v-model="payType"/>
    </van-dialog>
  </div>
</template>

<script>
import Scroll from '../../components/scroll/scroll'
import OrderStore from '../../components/order-store/order-store'
import OrderItem from '../../components/order-item/order-item'
import { post } from '../../common/js/http'
import PaySelect from '../../components/pay-select/pay-select'
import { mapState } from 'vuex'

export default {
  name: 'order-detail',
  components: {
    Scroll,
    OrderStore,
    OrderItem,
    PaySelect
  },
  data() {
    return {
      order: {},
      goods: [],
      status: ['待付款', '待发货', '订单已关闭', '卖家已发货', '交易成功', '退款'],
      statusIcon: [require('./wallet@2x.png'), require('./delivery@2x.png'), require('./shibai@2x.png'), require('./yifahuo@2x.png'), require('./finish@2x.png'), require('./tuikuan@2x.png')],
      refundStatus: ['', '待审核', '已同意', '退款中', '已完成'],
      cancelTime: 0,
      company: '',
      showPicker: false,
      expressNum: '',
      showPay: false,
      payType: 1,
      columns: ['圆通速递', '韵达快递', '中通快递', '顺丰速运', '邮政快递包裹', '百世快递', '京东物流', '申通快递', '天天快递', 'EMS', '邮政标准快递', '德邦', '德邦快递', '韵达快运', '百世快运', '中通快运', '圆通快运\n'],
      delta: -1
    }
  },
  mounted() {
    const { type } = this.$route.query
    if (type !== '4') {
      this.getDetail(this.$route.params.id)
    } else {
      this.getRefundDetail(this.$route.params.id)
    }
    if (this.routeHistory[this.routeHistory.length - 1] === 'order-detail' && this.routeHistory[this.routeHistory.length - 2] === 'order-detail') {
      this.delta = -2
    }
  },
  created() {
    this.$jsCallNative('setStatusBarBackColor', {
      color: '#fd255c'
    })
    this.$jsCallNative('setStatusBarTintStyle', {
      style: 'LIGHT'
    })
  },
  beforeDestroy() {
    this.$jsCallNative('setStatusBarBackColor', {
      color: '#ffffff'
    })
    this.$jsCallNative('setStatusBarTintStyle', {
      style: 'DARK'
    })
  },
  computed: {
    ...mapState(['routeHistory']),
    statusText() {
      if (this.order.status === 5 && this.order.return_status === 3) {
        return '退款失败'
      }
      return this.order.status < 5 ? this.status[this.order.status] : this.refundStatus[this.order.return_status]
    },
    currentReturn() {
      const return_status = this.order.return_status
      const express_no = this.order.express_no
      if (return_status === 1) return 1
      if (return_status === 2 && !express_no) return 2
      if (return_status === 2 && express_no) return 3
      if (return_status === 4) return 4
      return 0
    }
  },
  methods: {
    chat() {
      this.$jsCallNative('chat', {
        uid: this.order.shop.id + '',
        nick_name: this.order.nick_name
      })
    },
    inputBlur () {
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 200)
      }
    },
    evaluation(goods) {
      this.$router.push({
        name: 'evaluation',
        params: {
          goods
        }
      })
    },
    getRefundDetail(id) {
      const loading = this.$skeLoading('.order-detail', '0')
      post('/shop/order/returnOrderInfo', {
        ordergoodsid: id
      })
        .then(({ data: { data } }) => {
          this.goods = [{
            ...data.ordergoods,
            goodsId: data.ordergoods.id,
            title: data.ordergoods.goods.title,
            goods: null,
            size: data.ordergoods.color + (data.ordergoods.size || ''),
            cover: data.ordergoods.goods.thumb_urls.split(',')[0]
          }]
          this.order = {
            ...data.return_info,
            shop: data.ordergoods.shop,
            status: 5,
            return_status: data.return_info.status
          }
          if (data.return_info.status === 3) {
            this.refundStatus[2] = '已拒绝'
            this.statusIcon[5] = require('./shibai@2x.png')
          }
          this.$nextTick(() => {
            this.$refs.scroll.refresh()
          })
          loading.close()
        })
    },
    getDetail(id) {
      const loading = this.$skeLoading('.order-detail', '0')
      post('/shop/order/getOrderInfo', {
        suborderid: id
      })
        .then(({ data: { data } }) => {
          if (data.order.status === 3) {
            data.order.status = 4
          }
          if (data.order.delivery_status && data.order.status === 1) {
            data.order.status = 3
          }
          this.order = data.order
          if (data.order.status === 0) {
            this.cancelTime = new Date(this.order.create_time.replace(/-/g, '/')).getTime() + 15 * 60 * 1000 - Date.now()
          }
          this.goods = data.goods.map(goods => {
            return {
              ...goods,
              goodsId: goods.id,
              title: goods.goods.title,
              goods: null,
              size: goods.color + (goods.size || ''),
              cover: goods.goods.thumb_urls.split(',')[0]
            }
          })
          this.$nextTick(() => {
            this.$refs.scroll.refresh()
          })
          loading.close()
        })
    },
    confirmDelivery() {
      const loading = this.$toast.loading()
      post('/shop/order/confirmReceipt', {
        suborderid: this.order.id
      })
        .then(() => {
          this.getDetail()
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    refunds(goods) {
      this.$router.push({
        name: 'order-refunds',
        params: {
          goods,
          status: this.order.delivery_status
        }
      })
    },
    confirm(val) {
      this.company = val
      this.showPicker = false
    },
    openExpress() {
      if (!this.order.express_no) return
      this.$router.push({
        name: 'logistics',
        params: {
          cover: this.goods[0].cover,
          order: this.order
        }
      })
    },
    cancelOrder() {
      const loading = this.$toast.loading()
      post('/shop/order/cancelOrder', {
        suborderid: this.order.id
      })
        .then(() => {
          loading.close()
          this.$router.goBack(-1, true)
        })
        .catch(() => {
          loading.close()
        })
    },
    submitExpress() {
      if (!this.expressNum) {
        this.$toast.fail('请输入物流单号')
        return
      }
      const loading = this.$toast.loading()
      post('/shop/order/submitReturnExpress', {
        returnid: this.order.id,
        express_no: this.expressNum
      })
        .then(() => {
          loading.close()
          this.getRefundDetail()
        })
        .catch(() => {
          loading.close()
        })
    },
    buy() {
      this.$router.push({
        name: 'place-order',
        params: {
          order: [
            {
              shopid: this.order.shopid,
              store: this.order.shop,
              remark: '',
              goods: this.goods.map(item => {
                delete item.goodsId
                item.id = item.goodsid
                delete item.goodsid
                return item
              })
            }
          ]
        }
      })
    },
    nativePay() {
      window.payCallback = (status) => {
        switch (status) {
          case 'SUCCESS':
            this.getDetail()
            break
          case 'FAIL':
            this.$toast.fail('支付失败')
            break
          case 'CANCEL':
            this.$toast.fail('支付取消')
            break
        }
      }
      this.$jsCallNative('pay', {
        order_no: this.order.order_no,
        total_fee: process.env.NODE_ENV === 'development' ? 0.01 : this.order.total_price,
        pay_channel: this.payType
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "../../common/style/variable.styl"
  .order-detail
    padding-top 134px
    box-sizing border-box
  .status
    height 170px
    position fixed
    left 0
    top 0
    width 100%
    background #fd255c
    background-size cover
    .back
      height 70px
      display flex
      align-items center
      .icon-left
        font-size 36px
        color #fff
        padding-top 20px
        padding-left 30px
    .status-text
      display flex
      justify-content center
      align-items center
      &>img
        width 33px
        height 33px
        margin-right 14px
      &>p
        font-weight bold
        font-size 36px
        color #FFFFFF
.scroll
  border-top-left-radius 10px
  border-top-right-radius 10px
  background #F9F9F9
  &.send
    height calc(100% - 190px)
  .return-address
    margin-top 20px
    padding-top 34px
    background #fff
    &>h4
      padding-left 30px
      font-size 30px
      color #000
  .logistics
    height 118px
    display flex
    align-items center
    padding 0 30px
    border-top-left-radius 10px
    border-top-right-radius 10px
    background #fff
    &>img
      width 31px
      height 27px
      margin-right 19px
    &>p
      flex 1
      font-size 28px
      color #000000
    &>span
      font-size 30px
      color #FD255B
      font-weight bold
  .address
    margin-top 20px
    display flex
    padding 40px 30px
    background #fff
    &>img
      margin-right 24px
      width 25px
      height 30px
    .info
      flex 1
      &>p
        display flex
        margin-bottom 33px
        align-items center
        font-size 30px
        color #000
        &>span
          margin-left 22px
          font-size 24px
          color #747474
      &>span
        font-size 24px
        color #000000
  .order
    padding 38px 30px 31px 30px
    margin-top 24px
    margin-bottom 11px
    background #fff
    .goods
      padding-bottom 40px
    .control
      display flex
      align-items center
      justify-content flex-end
      &>p
        font-size 22px
        color #888888
        ::v-deep
          .van-count-down
            display inline
            font-size 22px
            color #888888
      &>button
        margin-left 18px
        width 126px
        height 53px
        border-radius 27px
        border 1px solid #FD255C
        font-size 24px
        color #FD255B
        background transparent
        outline none
  .connect
    height 87px
    margin-bottom 20px
    display flex
    align-items center
    justify-content center
    background #fff
    &>img
      margin-right 16px
      width 32px
      height 30px
    &>span
      font-size 26px
      color #000000
  .order-intro
    padding-left 30px
    margin-bottom 24px
    background-color #fff
    &>p
      height 79px
      display flex
      align-items center
      font-size 26px
      color #000
      &>span
        margin-right 40px
        color #6C6C6C
  .btns
    height 105px
    display flex
    align-items center
    justify-content flex-end
    padding 0 30px
    &>button
      margin-left 17px
      width 126px
      height 53px
      border-radius 27px
      background transparent
      border 1px solid #AAAAAA
      font-size 24px
      color #212121
      &.red
        border-color #FD255C
        color #FD255C
  .form
    margin-top 20px
    margin-bottom 74px
    background #fff
    .input
      height 115px
      display flex
      align-items center
      padding 0 30px
      justify-content space-between
      &>label
        font-size 30px
        color #979797
        &.active
          color #000
      .icon-right
        font-size 24px
        color #AEAEAE
      &>input
        flex 1
        margin-right 20px
        font-size 30px
        color #000
        height 100%
        border none
        outline none
        &::-webkit-input-placeholder
          color #979797
      .scan-icon
        font-weight bold
        font-size 34px
  .progress
    display flex
    height 161px
    padding 0 78px
    margin 20px 0
    align-items center
    justify-content space-between
    background #fff
    .step
      position relative
      &>p
        margin-bottom 41px
        font-size 26px
        color #333333
      &>img
        display block
        width 35px
        margin 0 auto
        height 35px
        border-radius 50%
        background rgba(56, 216, 110, 0.3)
      .line
        position absolute
        left 55px
        right -120px
        height 5px
        background #38D76E
        bottom 15px
        opacity 0.3
        z-index 1
</style>
